import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentLoaderComponent } from './components/component-loader/component-loader.component';
import { ViewSplitterComponent } from './components/view-splitter/view-splitter.component';

const components = [ComponentLoaderComponent, ViewSplitterComponent];

@NgModule({
  declarations: components,
  imports: [IonicModule, CommonModule, SagaPipeModule, TranslateModule],
  providers: [],
  exports: components
})
export class VisualModule {}
